import axios from 'axios'; // 引入axios

axios.defaults.timeout = 10000; // 超时
axios.defaults.baseURL = Const_Api_Root;
axios.defaults.withCredentials = true;
//http request 拦截器
axios.interceptors.request.use(
	config => {
		// const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
		config.data = JSON.stringify(config.data);
		config.headers = {
			'Content-Type': 'application/json'
		}
		if (/get/i.test(config.method)) { //判断get请求
			config.params = config.params || {};
			config.params.t = Date.parse(new Date()) / 1000; //添加时间戳
		}
		return config;
	},
	error => {
		return Promise.reject(err);
	}
);


//http response 拦截器
axios.interceptors.response.use(
	response => {
		return response;
	},
	error => {
		return Promise.reject(error)
	}
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(url, params = {}, otherOptions = {}) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: params,
			...otherOptions
		})
			.then(response => {
				resolve(response);
			})
			.catch(err => {
				reject(err)
			})
	})
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.post(url, data)
			.then(response => {
				resolve(response);
			}, err => {
				reject(err)
			})
	})
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.patch(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.put(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function Del(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.delete(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}



// WEBPACK FOOTER //
// ./src/request/http.js